module.exports = "/_next/static/images/Rectangle 3-92bea6907c4b8b3328c028c13043016b.png";